// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"287":"cbd93ae1","381":"d20161ca","596":"2a947c21","781":"cbd93ae1","922":"189cecef"}[chunkId] + ".chunk.css";
};